import { FC } from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import classnames from 'classnames';
import { BaseIconButtonProps } from './interface';

/** 删除图标 */
const DeleteIcon: FC<BaseIconButtonProps> = props => {
  const { className, ...restProps } = props;
  const classes = classnames('text-danger', 'move-pointer', className);
  return <DeleteOutlined className={classes} {...restProps} />;
};

export default DeleteIcon;
